import { BuilderProduct, ProductPlacement } from "@/store/builderSlice";
import { Box3 } from "three";
import * as THREE from 'three';
import {
    GLTF,
    GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader';

export const loadProduct = (product: BuilderProduct, productPlacement: ProductPlacement, roomBoundingBox: Box3, callback: Function) => {
    const productLoader = new GLTFLoader();
    productLoader.load(product.model3dUrl, function (gltf: GLTF) {
        
        convertOpacityToTransmission(gltf.scene);

        const scene: THREE.Group = gltf.scene;
        scene.name = 'productMesh';
        scene.scale.setScalar(0.5);
        scene.position.y = roomBoundingBox.min.y;
        scene.position.x = productPlacement.position.x;
        scene.position.z = productPlacement.position.z;

        scene.rotation.x = productPlacement.rotation.x;
        scene.rotation.y = productPlacement.rotation.y;
        scene.rotation.z = productPlacement.rotation.z;
        callback(scene);
    },
        (xhr) => {
            //console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
        },
        (error) => {
            console.log(error)
        }
    );
}

function convertOpacityToTransmission(model: THREE.Object3D): void {
  model.traverse((c: THREE.Object3D) => {
    if ((c as THREE.Mesh).material) {
      const mesh = c as THREE.Mesh;
      const material = mesh.material as
        | THREE.MeshBasicMaterial
        | THREE.MeshStandardMaterial
        | THREE.MeshPhysicalMaterial;

      if (material.opacity < 0.85 && material.opacity > 0.1) {
        const newMaterial = new THREE.MeshPhysicalMaterial({
          color: 0xffffff,
          metalness: 0,
          roughness: 0.04,
          ior: 1.5,
          envMapIntensity: 1,
          transmission: 1,
          thickness: 1,
          specularIntensity: 1,
          specularColor: new THREE.Color(0xffffff),
          opacity: 1,
          side: THREE.DoubleSide,
          transparent: true,
        });

        // Use type assertion with Record to allow string indexing
        const materialRecord = (material as unknown) as Record<string, any>;
        const newMaterialRecord = (newMaterial as unknown) as Record<
          string,
          any
        >;

        for (const key in materialRecord) {
          if (key in materialRecord) {
            if (materialRecord[key] === null) {
              continue;
            }

            if (materialRecord[key]?.isTexture) {
              newMaterialRecord[key] = materialRecord[key];
            } else if (
              materialRecord[key]?.copy &&
              materialRecord[key].constructor ===
                newMaterialRecord[key]?.constructor
            ) {
              newMaterialRecord[key].copy(materialRecord[key]);
            } else if (typeof materialRecord[key] === "number") {
              newMaterialRecord[key] = materialRecord[key];
            }
          }
        }

        newMaterial.opacity = 1.0;
        newMaterial.transmission = 1.0;
        mesh.material = newMaterial;
        console.log("aadarsh");
      }
    }
  });
}

export const disableCollisionByProduct = (productTypeName: string) => {
    return productTypeName === 'rugs';
}